import { IGAO } from '../../../../igao'

function App () {
  return (
    <div className='main'>
      <IGAO
        path='home_assessment'
        withTopMargin={false}
      />
    </div>
  )
}

export default App
